import axios from 'axios'
import { setConfig } from '../helpers/set_config.helper'

export async function getBotConversationCountByClientAndDate (user, token, dates, clientId) {
  const config = await setConfig(user, token)
  return await axios.get(`${process.env.REACT_APP_CONFIRMATION_API}bot/${dates}/${clientId}`, config)
}
